import { render, staticRenderFns } from "./vabTableScroll.vue?vue&type=template&id=8dc4ed32&scoped=true"
import script from "./vabTableScroll.vue?vue&type=script&lang=js"
export * from "./vabTableScroll.vue?vue&type=script&lang=js"
import style0 from "./vabTableScroll.vue?vue&type=style&index=0&id=8dc4ed32&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc4ed32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8dc4ed32')) {
      api.createRecord('8dc4ed32', component.options)
    } else {
      api.reload('8dc4ed32', component.options)
    }
    module.hot.accept("./vabTableScroll.vue?vue&type=template&id=8dc4ed32&scoped=true", function () {
      api.rerender('8dc4ed32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vab/components/VabTableScroll/vabTableScroll.vue"
export default component.exports